import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { token } from './Head.tokens.js';
import { bordersTemplate } from '@equinor/eds-utils';
import { InnerContext } from '../Inner.context.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children", "sticky"];
var StyledTableHead = styled.thead.withConfig({
  displayName: "Head__StyledTableHead",
  componentId: "sc-g9tch7-0"
})(["", " background:", ";"], bordersTemplate(token.border), token.background);
var Head = /*#__PURE__*/forwardRef(function Head(_ref, ref) {
  var children = _ref.children,
    sticky = _ref.sticky,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(InnerContext.Provider, {
    value: {
      variant: 'head',
      sticky: sticky
    },
    children: /*#__PURE__*/jsx(StyledTableHead, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref,
      children: children
    }))
  });
});

export { Head };
